export default __webpack_public_path__ + "static/media/00.3fb3d9f6.jpg";